import {
  resolveInitialLang,
  persistLang,
  AppLang,
  APP_LANGS,
  LANG_LABELS,
  LANG_SHORT,
  LANG_FLAGS,
} from './detectLang';
import { dashboardMessages, DashboardMessages } from './locales/dashboard';
import { pagesMessages, PagesMessages } from './locales/pages';
import { adminMessages, AdminMessages } from './locales/admin';

export type { AppLang };
export { APP_LANGS, LANG_LABELS, LANG_SHORT, LANG_FLAGS };
export { detectLang, isAppLang } from './detectLang';
export type { PagesMessages, DashboardMessages, AdminMessages };

type LangListener = (lang: AppLang) => void;

let currentLang: AppLang = resolveInitialLang();
const listeners = new Set<LangListener>();

if (typeof document !== 'undefined') {
  document.documentElement.lang = currentLang;
}

export function getLang(): AppLang {
  return currentLang;
}

export function setLang(lang: AppLang): void {
  if (lang === currentLang) return;
  currentLang = lang;
  persistLang(lang);
  if (typeof document !== 'undefined') {
    document.documentElement.lang = lang;
  }
  listeners.forEach((listener) => listener(lang));
}

export function subscribeLang(listener: LangListener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function getDashboardMessages(): DashboardMessages {
  return dashboardMessages[currentLang] || dashboardMessages.en;
}

export function getPagesMessages(): PagesMessages {
  return pagesMessages[currentLang] || pagesMessages.en;
}

export function getAdminMessages(): AdminMessages {
  return adminMessages[currentLang] || adminMessages.en;
}

/** Replace `{key}` placeholders in a message template. */
export function formatMessage(
  template: string,
  vars: Record<string, string | number | undefined | null>
): string {
  return template.replace(/\{(\w+)\}/g, (_, key: string) => {
    const value = vars[key];
    return value == null ? '' : String(value);
  });
}
